export default defineNuxtPlugin((nuxtApp) => {
    // Wrap $t method to handle null/undefined safely
    const originalT = nuxtApp.$i18n?.t
    if (originalT) {
        nuxtApp.$i18n.t = function(key, ...args) {
            if (!key || key === null || key === undefined || key === '') {
                return ''
            }
            if (nuxtApp.$i18n?.te && !nuxtApp.$i18n.te(key)) {
                return key
            }
            try {
                return originalT.call(this, key, ...args)
            } catch (e) {
                console.warn(`[i18n] Translation key not found: ${key}`)
                return key
            }
        }
        
        // Also set on Vue app global properties for Options API
        nuxtApp.vueApp.config.globalProperties.$t = nuxtApp.$i18n.t
    }

    // Override v-t directive to handle null/undefined safely
    nuxtApp.vueApp.directive('t', {
        beforeMount(el, binding, vnode) {
            const value = binding.value
            if (!value || value === null || value === undefined || value === '') {
                el.textContent = ''
                return
            }
            
            const i18n = nuxtApp.$i18n
            if (i18n?.te && !i18n.te(value)) {
                el.textContent = value
                return
            }

            if (i18n && i18n.t) {
                try {
                    el.textContent = i18n.t(value)
                } catch (e) {
                    console.warn(`[i18n] Translation key not found: ${value}`)
                    el.textContent = value
                }
            } else {
                el.textContent = value
            }
        },
        updated(el, binding) {
            const value = binding.value
            if (!value || value === null || value === undefined || value === '') {
                el.textContent = ''
                return
            }
            
            const i18n = nuxtApp.$i18n
            if (i18n?.te && !i18n.te(value)) {
                el.textContent = value
                return
            }

            if (i18n && i18n.t) {
                try {
                    el.textContent = i18n.t(value)
                } catch (e) {
                    console.warn(`[i18n] Translation key not found: ${value}`)
                    el.textContent = value
                }
            } else {
                el.textContent = value
            }
        }
    })
})
